import React from 'react';

import { Hash } from 'lucide-react';

import type { SimpleIconInterface } from './icon-utils';

export function NumberIcon(props: SimpleIconInterface): JSX.Element {
  const { className, dataCy, height, stroke, strokeWidth, style, width } = props;

  return (
    <Hash
      className={className}
      data-cy={dataCy}
      height={height ?? 18}
      stroke={stroke ?? 'currentColor'}
      strokeWidth={strokeWidth}
      style={style}
      width={width ?? 18}
    />
  );
}
